module.exports = "<app-about-banner></app-about-banner>\n<div class=\"main-content\">\n  <app-about-about></app-about-about>\n</div>\n"